import styled from 'styled-components';
import { renderRatio } from '@styles/utils/image';
import { primaryColor } from '@styles/utils';

export const DiagnosticsStepsImagesContainer = styled.div`
  padding-top: 64px;
  position: relative;
`;

export const DiagnosticsStepsImagesSlide = styled.li`
  cursor: pointer;

  > div {
    ${renderRatio(16 / 9)};
  }
`;

export const GalleryArrow = styled.button`
  position: absolute;
  display: block;
  cursor: pointer;
  top: 50%;
  z-index: 10;
  background-color: ${primaryColor(500)};
  outline: none;
  border: none;

  &:hover {
    outline: solid 3px ${primaryColor(200)};
  }
`;

export const DiagnosticsStepsImagesArrowLeft = styled(GalleryArrow)`
  padding: 15px 18px;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotate(180deg);
`;

export const DiagnosticsStepsImagesArrowRight = styled(GalleryArrow)`
  padding: 15px 18px;
  right: 0;
  transform: translateX(50%) translateY(-50%);
`;

export const DiagnosticsStepsItems = styled.div<{ length: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.length}, 1fr);
  grid-column-gap: 37px;
`;

export const DiagnosticsStepsItem = styled.div`
  cursor: pointer;

  > div {
    ${renderRatio(16 / 9)};
  }
`;
